import { theme } from 'ui/theme';

export const Spark = () => {
  return (
    <svg width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.552734 14.8395C0.552734 14.8395 11.6256 13.0135 13.5307 0.762207C13.5307 0.762207 14.551 12.3057 26.6517 14.8358C26.6517 14.8358 15.4546 16.6919 13.5307 28.9055C13.5307 28.9093 11.5051 16.7107 0.552734 14.8395Z"
        fill={theme.colors.action.navigation.standard.highlight}
      />
    </svg>
  );
};
